import Model from "./Model";
import IUser from "./interfaces/IUser";
import { Position } from "./Position";
import Isocron from "./Isocron";
import { Scouting } from ".";
import { ScoutingMetadata } from "./Scouting";

export enum SCOUTING_PLACE_SOURCE {
  GOOGLE_PLACES = "google_places",
  CLIENT = "client",
}

export default class ScoutingPlace extends Model {
  static type = "scoutingPlaces";

  name!: string;
  fullAddress!: string;
  position!: Position;
  isocron!: Isocron;
  highlighted = false;
  source!: string;
  sourceId!: string;

  clientPlaceId?: string;
  metadata?: ScoutingMetadata;

  static dummy() {
    let place = new ScoutingPlace();
    place.name = "Milano";
    place.position = new Position(45.47741454797728, 9.199590998404119);
    return place;
  }

  static fromGooglePlace(googlePlace: any) {
    let place = new ScoutingPlace();
    place.id = googlePlace.place_id;
    place.sourceId = googlePlace.place_id;
    place.source = "google_places";
    place.name = googlePlace.name;
    const position = googlePlace.geometry.location;
    place.position = new Position(position.lng(), position.lat());
    place.fullAddress = googlePlace.formatted_address;
    return place;
  }

  hasScoutingIsocron(scouting: Scouting): boolean {
    return (
      this.isocron?.isocronMeansType === scouting.isocronMeansType &&
      this.isocron?.isocronType === scouting.isocronType &&
      this.isocron?.isocronRange === scouting.isocronRange
    );
  }

  get isIsocronReady(): boolean {
    return !!this.isocron?.isocron?.length && this.isocron?.isCompleted;
  }

  get toJson() {
    return {
      name: this.name,
      source: "google_places",
      position: this.position,
      sourceId: this.sourceId,
      fullAddress: this.fullAddress,
    };
  }
}
